import axios from "axios"
import gl from './global';




if (process.env.NODE_ENV == "development") {
  //开发环境
  axios.defaults.baseURL = "/"
} else if (process.env.NODE_ENV == "production") {
  //生产环境
  axios.defaults.baseURL = "/"
}
export default {
  //  获取志愿者信息
  getUserByID(params) {
    return axios.get(gl.base + `/api/volunteer/getLoginInfo`, { params })
  },
  //  添加志愿者信息
  register(params) {
    return axios.post(gl.base + `/api/volunteer/add`, params)
  },
  //  编辑志愿者信息
  editMessage(params) {
    return axios.post(gl.base + `/api/volunteer/update`, params)
  },
  // 申请保留资格
  keeyQuality(params) {
    return axios.get(gl.base + `/api/integralResult/keeyQuality`, { params })
  },
  // 获取申请资格不用审核的分数线
  getAuditScore() {
    return axios.get(gl.base + `/api/integralResult/getAuditScore`, null)
  },
  uploadUrl: gl.base + '/api/file/uploadFile',

  /****************************************我的展厅************************************ */
  //获取展厅列表
  getHallList(params) {
    return axios.get(gl.base + `/api/myExhibitionHall/getAllExhibitionHall`, { params })
  },
  // GET /api/myExhibitionHall/getMine 获取我的展厅列表
  getMyHallList(params) {
    return axios.get(gl.base + `/api/myExhibitionHall/getMine`, { params })

  },
  // POST /api/myExhibitionHall/applyUnlock 申请解锁展厅
  applyUnlock(params) {
    return axios.post(gl.base + `/api/myExhibitionHall/applyUnlock`, params)
  },
  //  展厅详情
  getHallDetail(params) {
    return axios.get(gl.base + `/api/myExhibitionHall/showDetails`, { params })
  },
  // 获取评论列表
  getHallComment(params) {
    return axios.get(gl.base + `/api/myExhibitionHall/showCommentList`, { params })
  },
  // POST /api/myExhibitionHall/comment发表评论
  sendComment(params) {
    return axios.post(gl.base + `/api/myExhibitionHall/comment`, params)
  },
  //  删除评论
  delComment(params) {
    return axios.get(gl.base + `/api/myExhibitionHall/delComment`, { params })
  },


  /*****************************************活动中心********************************** */
  // GET /api/activityCenter/unlockExhibitionHallData 获取已解锁展厅信息
  unlockExhibitionHallData(params) {
    return axios.get(gl.base + `/api/activityCenter/unlockExhibitionHallData`, { params })
  },

  //获取指定时间讲解信息
  getExplainInfoByDate(params) {
    return axios.post(gl.base + `/api/activityCenter/getExplainInfoByDate`, params)
  },
  // POST /api/activityCenter/getExplainSignStatus 获取指定时间段内讲解报名状态信息
  getExplainSignStatus(params) {
    return axios.post(gl.base + `/api/activityCenter/getExplainSignStatus`, params)
  },

  //  获取策划、其他活动信息
  getActivityList(params) {
    return axios.post(gl.base + `/api/activityCenter/getActivityList`, params)
  },

  // POST /api/activityCenter/showActivityDetail 获取策划、其他活动详情
  showActivityDetail(params) {
    return axios.post(gl.base + `/api/activityCenter/showActivityDetail`, params)
  },
  //获取指定时间段内服务报名状态信息
  getServiceSignStatus(params) {
    return axios.post(gl.base + `/api/activityCenter/getServiceSignStatus`, params)
  },

  /*****************************************报名*************************************** */
  // POST /api/task/drawTask 报名
  drawTask(params) {
    return axios.post(gl.base + `/api/task/drawTask`, params)
  },
  // 退出报名提示
  cancelBefore(params) {
    return axios.post(gl.base + `/api/task/cancelBefore`, params)
  },
  // POST /api/task/cancel 退出报名
  cancelTask(params) {
    return axios.post(gl.base + `/api/task/cancel`, params)
  },

  /*****************************************帮助中心 ******************************** */
  //GET /api/helpCenter/queryList 查询帮助中心列表
  helpList(params) {
    return axios.get(gl.base + `/api/helpCenter/queryList`, { params })
  },
  //GET /api/helpCenter/showDetails 数据详情
  helpDetail(params) {
    return axios.get(gl.base + `/api/helpCenter/showDetails`, { params })
  },

  /*****************************************积分规则******************************** */
  //GET /api/integrationRules/query 查看积分规则
  integrationList(params) {
    return axios.get(gl.base + `/api/integrationRules/query`, { params })
  },
  // POST /api/integral/getCurrentIntegral 获取本年度积分信息
  // POST /api/integral/getIntegralItem 获取积分明细
  // POST /api/integral/getIntegralResultList 获取历史积分列表

  getCurrentIntegral(params) {
    return axios.post(gl.base + `/api/integral/getCurrentIntegral`, params)
  },
  getIntegralItem(params) {
    return axios.post(gl.base + `/api/integral/getIntegralItem`, params)
  },
  getIntegralResultList(params) {
    return axios.post(gl.base + `/api/integral/getIntegralResultList`, params)
  },


  /*****************************************注册协议接口******************************** */
  // 查看注册协议
  registerRules(params) {
    return axios.get(gl.base + `/api/registerProtocol/query`, { params })
  },



  /*****************************************规章条例接口 ******************************** */
  // 查询规章条例
  ruleList(params) {
    return axios.get(gl.base + `/api/regulations/queryList`, { params })
  },
  //数据详情
  ruleDetail(params) {
    return axios.get(gl.base + `/api/regulations/showDetails`, { params })
  },


  /*************************************** 活动统计/我的服务统计/***************************************/
  // 获取志愿者的报名活动信息统计
  getActivityStatistic(params) {
    return axios.post(gl.base + `/api/activityStatistic/getActivityStatistic`, params)
  },
  //获取指定类型、指定状态的活动信息
  getMyTaskByTypeAndStatus(params) {
    return axios.post(gl.base + `/api/activityStatistic/getMyTaskByTypeAndStatus`, params)
  },
  //  获取活动报名详细信息
  getDetailInfo(params) {
    return axios.post(gl.base + `/api/activityStatistic/getDetailInfo`, params)
  },


  /*************************************** 我的申请/***************************************/
  // 解锁展厅申请信息

  getExhibitionApplication(params) {
    return axios.post(gl.base + `/api/myApplication/getExhibitionApplication`, params)
  },
  //  解锁展厅申请详情
  getExhibitionApplicationDetail(params) {
    return axios.get(gl.base + `/api/myApplication/getExhibitionApplicationDetail`, { params })
  },

  //  退出报名申请信息

  getCancelApplication(params) {
    return axios.post(gl.base + `/api/myApplication/getCancelApplication`, params)
  },

  // 保留资格申请详情
  getIntegralResultDetail(params) {
    return axios.post(gl.base + `/api/myApplication/getIntegralResultDetail`, params)
  },


  /*************************************** 我的消息***************************************/
  //  查询消息列表
  messageList(params) {
    return axios.get(gl.base + `/api/message/queryList`, { params })
  },
  // 
  messageListNew(params) {
    return axios.get(gl.base + `/api/message/queryUnreadCount`, { params })
  },

  //  消息详情
  messageDetail(params) {
    return axios.get(gl.base + `/api/message/showDetails`, { params })
  },



  /*************************************** 我的日程 ***************************************/
  // 获取指定年月有活动的日期
  getExistTaskDate(params) {
    return axios.post(gl.base + `/api/task/getExistTaskDate`, params)
  },
  //  获取某一天的活动（就餐）
  getTaskInfoByDate(params) {
    return axios.post(gl.base + `/api/task/getTaskInfoByDate`, params)
  },


  /*************************************** 就餐管理 ***************************************/
  // 申请就餐
  mealApply(params) {
    return axios.post(gl.base + `/api/meal/mealApply`, params)
  },
  // 取消就餐
  mealCancel(params) {
    return axios.post(gl.base + `/api/meal/mealCancel`, params)
  },



  /*************************************** 服务日程 ***************************************/
  // PC端获取服务日程
  getWebServiceSchedule(params) {
    return axios.post(gl.base + `/api/serviceSchedule/getWebServiceSchedule`, params)
  },

  //  PC端服务日程导出
  exportWebServiceSchedule(params) {
    return axios.get(gl.base + `/api/serviceSchedule/exportWebServiceSchedule`, { params })
  },
  exportWebServiceSchedules: gl.base + `/api/serviceSchedule/exportWebServiceSchedule`,

  /*************************************** 首页 ***************************************/
  // 获取我的数据信息
  getMyData(params) {
    return axios.post(gl.base + `/api/myCenter/getMyData`, params)
  },

  // 获取我的日程信息

  getMySchedule(params) {
    return axios.post(gl.base + `/api/myCenter/getMySchedule`, params)
  },

  // POST /api/myCenter/logout 退出登录
  logout(params) {
    return axios.post(gl.base + `/api/myCenter/logout`, params)
  },

  // 获取志愿者编号
  getHistoryNumber(params) {
    return axios.get(gl.base + `/api/volunteer/getHistoryNumber`, { params })
  },
  // 查看试用期要求
  getRegularRules(params) {
    return axios.post(gl.base + `/api/myCenter/getRegularRules`, params)
  },
}